export default __webpack_public_path__ + "static/media/mumbai.64889777.svg";